import Link from "next/link";

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-stone-200 bg-stone-50 px-4 py-6 text-center text-sm text-stone-500 sm:px-6">
      <p>
        © {year} Diaspora One.{" "}
        <Link
          href="https://henga.co/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-stone-600 underline-offset-2 hover:text-stone-900 hover:underline"
        >
          Built by Henga
        </Link>
      </p>
    </footer>
  );
}
